import React from 'react';
import './Passwordresetdone.css';
import tickicon from '../../images/Tick-icon.svg';
import logolight from '../../images/urology-logo-white.svg';
import urologylogotransparent from '../../images/urology-logo-transparent.png';

import { Link } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";

function PasswordresetdoneComponent() {
    return (
      <>
        <section className='passresetdone-blk-main'>
            <div className='passresetdone-bg-blk'>
                <div className='logo-top'>
                    <img src={urologylogotransparent} alt='logo'></img>
                </div>
            </div>
            <div className='passresetdone-text-blk d-flex align-items-center'>
                <div className='passresetdone-content'>
                    <div className='keyicon'>
                        <img src={tickicon} alt='tick'></img>
                    </div>
                    <div className='passresetdone-main-text'>
                        <h2>Password Reset</h2>
                        <p>Your password has been successfully reset.
                        Click below to sign in magically.</p>
                        <Link to="/entercode" variant="primary" className='dark-btn reset-btn'>Continue</Link>
                    </div>
                    <Link to="/signin" className='backto-blk'><FaArrowLeftLong/>Back to log in</Link>
                </div>
            </div>
        </section>
      </>
    )
}

export default PasswordresetdoneComponent;